export default "__VITE_ASSET__Co4sr49N__"